<template>
	<FormGroup
		:state="startValid && endValid"
		:invalid-feedback="error"
		feedback-beneath
	>
		<div class="d-flex align-items-md-center flex-column flex-md-row">
			<div>
				<DatePicker
					v-model="start"
					:disabled="disabled"
					:years-in-past="80"
					:years-in-future="0"
					year-reverse
					:with-day="false"
					switch-month-year
					class="w-auto"
					@input="emitChangeEvent"
				/>
			</div>
			<div class="mx-md-3">bis</div>
			<div>
				<div class="d-flex align-items-center md-ml-1">
					<DatePicker
						v-model="end"
						:disabled="disabled || !endDateEligible"
						:years-in-past="80"
						:years-in-future="0"
						year-reverse
						:with-day="false"
						switch-month-year
						class="w-auto"
						@input="emitChangeEvent"
					/>
				</div>
			</div>
			<div class="ml-md-3">
				<b-form-checkbox v-model="ongoing" @input="emitChangeEvent">aktuell</b-form-checkbox>
			</div>
		</div>
	</FormGroup>
</template>

<script>
import PopUp from "@/vue/common/PopUp";
import FormGroup from "@/vue/common/form/Group";
import DatePicker from "@/vue/common/form/DatePicker"
import Select from "@/vue/common/form/Select";
import {isDefined} from "@/helper/Value";
import {getMonthYearComparisonValue} from "@/helper/Date";
import {DateTime} from "luxon";

const END_TYPE_TODAY = 'today';
const END_TYPE_DATE = 'date';

export default {

	components: {
		FormGroup,
		DatePicker,
		Select,
		PopUp,
	},

	props: {
		value: {
			type: Object,
			required: false,
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		showErrors: {
			type: Boolean,
			required: false,
			default: true,
		},
		showRequiredError: {
			type: Boolean,
			required: false,
			default: true,
		},
	},

	data ()
	{
		let ongoing = false;

		if (this.value && !isDefined(this.value.end))
		{
			ongoing = true;
		}

		return {
			start: this.value?.start,
			end: this.value?.end,
			ongoing,
		};
	},

	computed: {
		startValid ()
		{
			return !isDefined(this.startError);
		},
		startError ()
		{
			if (!isDefined(this.start))
			{
				return {
					show: this.showErrors && this.showRequiredError,
					message: 'Bitte triff eine Auswahl'
				};
			}

			const now = DateTime.now();

			const monthYearComparisonValueNow = getMonthYearComparisonValue(now.month, now.year);

			if (getMonthYearComparisonValue(this.start.month, this.start.year) > monthYearComparisonValueNow)
			{
				return {
					show: this.showErrors,
					message: 'Das Startdatum darf nicht in der Zukunft liegen'
				};
			}

			return null;
		},
		endDateEligible ()
		{
			return !this.ongoing;
		},
		endValid ()
		{
			return !isDefined(this.endError);
		},
		endError ()
		{
			if (!this.endDateEligible)
			{
				return null;
			}

			if (!isDefined(this.end))
			{
				return {
					show: this.showErrors && this.showRequiredError,
					message: 'Bitte gib ein Datum ein'
				};
			}

			if (this.start)
			{
				const monthYearComparisonValueStart = getMonthYearComparisonValue(this.start.month, this.start.year);
				const monthYearComparisonValueEnd = getMonthYearComparisonValue(this.end.month, this.end.year);

				if (monthYearComparisonValueStart > monthYearComparisonValueEnd)
				{
					return {
						show: this.showErrors,
						message: 'Ungültiger Zeitraum'
					};
				}
			}

			const now = DateTime.now();

			const monthYearComparisonValueNow = getMonthYearComparisonValue(now.month, now.year);

			if (getMonthYearComparisonValue(this.end.month, this.end.year) > monthYearComparisonValueNow)
			{
				return {
					show: this.showErrors,
					message: 'Das Enddatum darf nicht in der Zukunft liegen'
				};
			}

			return null;
		},
		error ()
		{
			if (this.startError?.show)
			{
				return this.startError.message;
			}

			if (this.endError?.show)
			{
				return this.endError.message;
			}

			return undefined;
		},
		dataValid ()
		{
			return this.startValid && this.endValid;
		},
	},

	methods: {
		emitChangeEvent ()
		{
			if (!this.dataValid)
			{
				this.$emit('input', undefined);
				return;
			}

			this.$emit('input', {
				start: this.start,
				end: this.endDateEligible
					? this.end
					: null
			});
		}
	}
}
</script>
